// Centralised app-wide constants and demo data

// Tender type options used in landing Hero search
export const TENDER_TYPE_OPTIONS = [
  { value: "tenders", label: "Tenders" },
  { value: "results", label: "Results" },
  // { value: "boq", label: "BOQ" },
];

// Summary filter options used on search-list header
export const JOB_FILTER_OPTIONS = [
  { value: "value", label: "Tender Count & Value" },
  { value: "state", label: "Tender State" },
  { value: "department", label: "Department" },
  { value: "ownership", label: "Ownership" },
];

// Summary filter options used on search-results header
export const RESULT_FILTER_OPTIONS = [
  { value: "value", label: "Contract Value" },
  { value: "state", label: "Who Won Max" },
  { value: "department", label: "State" },
  { value: "ownership", label: "Department" },
];

// Demo tenders for summary table when API data is not available
export const DEMO_SUMMARY_TENDERS = [
  {
    id: "demo-1",
    tenderId: "APX-1001",
    title: "Road Improvement Work in Urban Area",
    location: "Ahmedabad, Gujarat",
    deadline: "12 July, 2025",
  },
  {
    id: "demo-2",
    tenderId: "APX-1002",
    title: "Construction of Office Building Complex",
    location: "Mumbai, Maharashtra",
    deadline: "18 July, 2025",
  },
  {
    id: "demo-3",
    tenderId: "APX-1003",
    title: "Bridge Repair and Strengthening Project",
    location: "Kolkata, West Bengal",
    deadline: "22 July, 2025",
  },
  {
    id: "demo-4",
    tenderId: "APX-1004",
    title: "Water Supply Pipeline Laying Work",
    location: "Jaipur, Rajasthan",
    deadline: "30 July, 2025",
  },
  {
    id: "demo-5",
    tenderId: "APX-1005",
    title: "Construction of School Building",
    location: "Bengaluru, Karnataka",
    deadline: "05 August, 2025",
  },
];

// Advanced Search Form Options
export const SELECT_TYPE_OPTIONS = [
  { value: "buy", label: "Buy" },
  { value: "sell", label: "Sell" },
  { value: "contract", label: "Contract" },
];

export const WORD_SEARCH_TYPE = {
  WORD_SEARCH: "word_search",
  WITHIN_FILTER: "within_filter",
};

export const WORD_SEARCH_TYPE_OPTIONS = [
  { value: WORD_SEARCH_TYPE.WORD_SEARCH, label: "Word Search" },
  { value: WORD_SEARCH_TYPE.WITHIN_FILTER, label: "Within Filter" },
];

export const ZONE_OPTIONS = [
  { value: "east", label: "East" },
  { value: "south", label: "South" },
  { value: "north", label: "North" },
  { value: "west", label: "West" },
  { value: "central", label: "Central" },
];

export const AUTHORITY_OWNERSHIP_OPTIONS = [
  { value: "association", label: "Association" },
  { value: "central_government", label: "Central Government" },
  { value: "co_operative", label: "Co-operative" },
  { value: "corporation", label: "Corporation" },
  { value: "government", label: "Government" },
  { value: "private_sector", label: "Private Sector" },
  { value: "public_sector", label: "Public Sector Undertaking" },
  { value: "state_government", label: "State Government" },
  { value: "trust", label: "Trust" },
  { value: "unknown", label: "Unknown" },
];

export const VALUE_FILTER_OPTIONS = [
  { value: "thousand", label: "Thousand" },
  { value: "lakh", label: "Lakh" },
  { value: "crore", label: "Crore" },
];

// BOQ Type options
export const BOQ_TYPE_OPTIONS = [
  { value: "tender", label: "Tender BOQ" },
  { value: "result", label: "Result BOQ" },
];


